
import { ReactNode } from 'react'
import './DrawerDetailContent.css'

const DrawerDetailContent = ({ children }: { children: ReactNode }) => {
    return (
        <div className='drawer-detail__content'>{children}</div>
    )
}

export default DrawerDetailContent